/**
 * Per-device UserStorageService key for the canvasser's currently-active work
 * context ("Campaign" picker on My Day) — a session/device preference, not
 * synced org state (design doc §6.5: "one pick per shift").
 */
export const ACTIVE_WORK_CONTEXT_KEY = 'active-work-context';
